<template>
  <div class="plan-frequency-select">
    <div
      v-for="opt in options"
      :key="opt.value"
      role="button"
      tabindex="0"
      class="plan-frequency-card"
      :class="{ 'plan-frequency-card--selected': modelValue === opt.value }"
      @click="$emit('update:modelValue', opt.value)"
      @keydown.enter.prevent="$emit('update:modelValue', opt.value)"
      @keydown.space.prevent="$emit('update:modelValue', opt.value)"
    >
      <span v-if="opt.mostPopular" class="plan-frequency-card__tag">Most Popular</span>
      <div class="plan-frequency-card__content">
        <div class="plan-frequency-card__main">
          <h3 class="plan-frequency-card__title">{{ opt.label }}</h3>
          <div v-if="opt.originalPrice" class="plan-frequency-card__pricing">
            <span class="plan-frequency-card__original">{{ opt.originalPrice }}</span>
            <span class="plan-frequency-card__price plan-frequency-card__price--accent">{{ opt.price }}</span>
          </div>
        </div>
        <div class="plan-frequency-card__right">
          <span class="plan-frequency-card__monthly-price">{{ opt.priceSub || opt.price }}</span>
          <span class="plan-frequency-card__gap"></span>
          <span v-if="modelValue === opt.value" class="plan-frequency-card__check" aria-hidden="true">
            <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5.5L5 9.5L13 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span v-else class="plan-frequency-card__empty" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlanFrequencySelect',
  compatConfig: {
    COMPONENT_V_MODEL: false
  },
  props: {
    modelValue: { type: String, default: 'yearly' },
    options: { type: Array, required: true }
  }
};
</script>

<style scoped>
/* Match SegmentControl palette: #4DA1FF, #E7F5FE, #CED0DA, #707070, #323C47. Dark blue tag: var(--color-nav-bg) */
.plan-frequency-select {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.plan-frequency-card {
  position: relative;
  min-height: 96px;
  padding: 1rem 1.25rem;
  background: var(--color-bg-surface);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.plan-frequency-card:hover {
  border-color: var(--color-primary);
}
.plan-frequency-card--selected {
  min-height: 120px;
  background: var(--color-selected);
  border: 2px solid var(--color-primary);
}
.plan-frequency-card--selected:hover {
  border-color: var(--color-primary);
}
/* Tag sits on the border of the card, overlapping top edge - dark blue */
.plan-frequency-card__tag {
  position: absolute;
  top: -11px;
  right: 16px;
  padding: 4px 12px;
  background: var(--color-nav-bg);
  color: var(--color-text-on-nav);
  font-size: 12px;
  font-weight: 700;
  border-radius: 4px;
  font-family: var(--font-regular);
  z-index: 1;
}
.plan-frequency-card__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 88px;
}
.plan-frequency-card--selected .plan-frequency-card__content {
  min-height: 96px;
}
.plan-frequency-card__main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.25rem;
}
/* H3 styling for Yearly/Monthly (28px) */
.plan-frequency-card__title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: var(--color-text);
  font-family: var(--font-regular);
}
.plan-frequency-card--selected .plan-frequency-card__title {
  color: var(--color-primary);
}
.plan-frequency-card__pricing {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem;
}
.plan-frequency-card__original {
  font-size: 0.95rem;
  color: var(--color-text-muted);
  text-decoration: line-through;
}
.plan-frequency-card__price {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text);
}
.plan-frequency-card__price--accent {
  color: var(--color-primary);
}
/* Right block: monthly price + 16px gap + checkbox, aligned with title */
.plan-frequency-card__right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.plan-frequency-card__monthly-price {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text);
}
.plan-frequency-card--selected .plan-frequency-card__monthly-price {
  color: var(--color-text);
}
.plan-frequency-card__gap {
  width: 16px;
  flex-shrink: 0;
}
.plan-frequency-card__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: var(--color-bg-surface);
  border-radius: 6px;
  border: 2px solid var(--color-nav-bg);
  color: var(--color-nav-bg);
  flex-shrink: 0;
}
.plan-frequency-card__empty {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: var(--color-bg-surface);
  border-radius: 6px;
  border: 1px solid var(--color-border);
  flex-shrink: 0;
}
</style>
